<script lang="ts">
	import ProfileInputFrame from "./ProfileInputFrame.svelte";
	import CancelButton from "./CancelButton.svelte";
	import Message from "./Message.svelte";
	import { HubProfileTextInput, DefaultButton } from "@hitit/new_ui";
	import ProfileViewer from "./ProfileViewer.svelte";
	import { parse, isValid, isAfter, isBefore, format } from "date-fns";
	import { t, api } from "@hitit/hub/src/stores";
	import type { ProfileData } from "@hitit/api";

	export let profile: ProfileData;
	export let userId: string | undefined = undefined;
	//
	let birth = profile.datebirth || "";
	let editmode = false;
	let loading = false;

	let year = "";
	let month = "";
	let day = "";

	$: parsed = parse(`${year}-${month}-${day}`, "yyyy-MM-dd", new Date());
	$: errorMessage = "";
	async function updateBirthDay() {
		try {
			loading = true;
			errorMessage = !isValid(parsed)
				? $t("hub.profile.birthday_error")
				: isAfter(parsed, new Date())
				? $t("hub.profile.birthday_error_future")
				: isBefore(parsed, new Date(1900))
				? $t("hub.profile.birthday_error_past")
				: "";

			if (errorMessage) {
				return;
			}

			const formatted = format(parsed, "yyyy-MM-dd");
			const newProfile = Object.assign({}, profile, { datebirth: formatted });
			await $api.updateProfile(newProfile, userId);
			profile = newProfile;
			birth = formatted;
			editmode = false;
		} catch (e) {
			console.log(e);
		} finally {
			loading = false;
		}
	}

	$: saveButtonDisabled =
		Boolean(errorMessage || loading) || !(year && month && day);
	$: backgroundColor = saveButtonDisabled ? "#a5c1f9" : "#6b93f3";

</script>

<div class="container" class:editmode>
	{#if !editmode}
		<ProfileViewer
			name={$t('hub.profile.birthday')}
			value={birth}
			editIcon={!(profile.cellphone?.includes("Azure"))}
			on:click={() => {
				editmode = true;
			}} />
	{:else}
		<div class="frame-wrapper">
			<ProfileInputFrame name={$t('hub.profile.current_birth')}>
				<span class="current_birth">{birth}</span>
			</ProfileInputFrame>
			<div class="message-frame">
				<ProfileInputFrame name={$t('hub.profile.new_birth')}>
					<div class="input">
						<HubProfileTextInput
							bind:value={year}
							on:input={() => (errorMessage = '')}
							clearCallback={() => (year = '')}
							length={4}
							placeholder={'YYYY'} />
					</div>
					<div class="input">
						<HubProfileTextInput
							on:input={() => (errorMessage = '')}
							bind:value={month}
							clearCallback={() => (month = '')}
							length={2}
							placeholder={'MM'} />
					</div>
					<div class="input">
						<HubProfileTextInput
							on:input={() => (errorMessage = '')}
							bind:value={day}
							clearCallback={() => (day = '')}
							length={2}
							placeholder={'DD'} />
					</div>
				</ProfileInputFrame>
				<Message messageTrnaslation={errorMessage} error />
			</div>
		</div>
		<div class="button-wrapper">
			<div class="button-box done" class:hasError={errorMessage !== ''}>
				<DefaultButton
					-birth-save={true}
					fitmode
					nonePadding
					background={backgroundColor}
					disabled={saveButtonDisabled}
					on:click={() => updateBirthDay()}
					isLoading={loading}>
					<span class="white">{$t('global.save')}</span>
				</DefaultButton>
			</div>
		</div>
		<div class="cancelbox">
			<CancelButton
				on:click={() => {
					editmode = false;
				}} />
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 0 20px;

		:global(.-birth-save) {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		&.editmode {
			padding: 20px 20px;
			background-color: #e6e7ed;
			position: relative;
			.frame-wrapper {
				flex-grow: 1;
				display: flex;
				flex-direction: column;
				gap: 10px;
			}
			.button-box {
				flex-grow: 1;
				height: 32px;

				&.done {
					.white {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 100%;
						height: 100%;
						font-size: 1rem;
						color: white;
					}
				}
				span {
					margin-top: -1px;
				}
			}
		}

		.cancelbox {
			position: absolute;
			top: 10px;
			right: 10px;
		}
	}

	.input {
		max-width: calc((100% / 3));
		flex-basis: 33.333333%;
	}
	.message-frame {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.white {
		color: white;
		font-size: 1rem;
		font-weight: 500;
	}

	.current_birth {
		font-weight: 500;
		color: #46474b;
	}

	@include DesktopSize {
		.container {
			gap: 10px;
			padding: 0 40px;

			&.editmode {
				padding: 20px 40px;
				flex-direction: row;
				.frame-wrapper {
					gap: 20px;
				}

				.button-wrapper {
					display: flex;
					flex-basis: 150px;
					.button-box {
						min-width: 150px;
						flex-basis: 150px;
						flex-grow: 0;
						box-sizing: border-box;
						height: 40px;
						margin-top: auto;
						&.hasError {
							margin-bottom: 23px;
						}
						&.done {
							.white {
								font-size: 1.25rem;
							}
						}
					}
				}
			}
			.cancelbox {
				top: 20px;
				right: 20px;
			}
		}
		.white {
			font-size: 1.25rem;
		}
		.input {
			max-width: 100px;
			flex-basis: 100px;
		}
		.current_birth {
			font-size: 1.25rem;
		}
	}

</style>
